import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { GruposPagoService } from '../../services/grupos-pago/grupos-pago.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';


export interface DialogData 
{   
    id: any
    totalPagar: any
    fechaPagoEstimada: any
    estado: any
    agrupaciones: any 
}


@Component({
    selector: 'app-grupos-pago',
    templateUrl: '../../pages/grupos-pago/exportar-excel.component.html',
    styleUrls: ['../../pages/grupos-pago/grupos-pago.component.css']
})

export class DialogExportarExcel implements OnInit
{  
  
    agrupacionesFinales: any
    agrupaciones: any = 
    { 
        id: this.data.id,
        estado: this.data.estado
     
       
    }
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    

    constructor( public dialogRef: MatDialogRef<DialogExportarExcel>,  private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private gruposPagoService: GruposPagoService) 
    { 
    this.agrupaciones=data;

    }
   
    ngOnInit(): void {     
      //  var data = [];  
        
        let vm = this
        this.agrupaciones=this.data;
        vm.agrupacionesFinales = this.data
        vm.agrupacionesFinales =  vm.agrupaciones
        vm.config.totalItems = vm.agrupaciones.length
        
    }
   
    estado: any = "CREADO"
    estados: any = ["CREADO", "FIRMADO", "PAGADO"]
    
    onCancelarClick(): void { this.dialogRef.close() }  
    
    
    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
    }

    cambiaCantidadRegistros()
    {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }

    
}